import { APP_ROUTES } from "@src/constants";
import { unfreezeAppointment } from "@src/services/unfreeze-appointment.service";

type NavigateWithUtm = (to: string, options?: { replace?: boolean; state?: any }) => void;

export const navigateToContactUs = (
  navigate: NavigateWithUtm,
  userUuid?: string,
  options?: { replace?: boolean; state?: any },
  shouldUnfreeze: boolean = true,
): void => {
  if (shouldUnfreeze && userUuid) {
    // Best-effort unfreeze before navigation; do not block user routing.
    unfreezeAppointment(userUuid).catch(() => {});
  }

  if (options) {
    navigate(APP_ROUTES.CONTACT_US, options);
  } else {
    navigate(APP_ROUTES.CONTACT_US);
  }
};
